import type { LandingData } from "../data/types"

export function CoverageLine({ data }: { data: LandingData }) {
  const stale = data.build.snapshot_age_days > 7
  return (
    <p className={`coverage mono${stale ? " stale" : ""}`}>
      BUILD {data.build.snapshot_date} · {data.stats.symbols} SYMBOLS · {data.stats.etfs} ETFS · {data.stats.exchanges} EXCHANGES{stale ? " · STALE" : ""}
    </p>
  )
}
